<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="this.$l('form_label_expenseType') || '费用类型'"
              prop="expenseType"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.expenseType"
                :body="{ dictType: 'expenseType' }"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="this.$l('INDEX.table_label_price') || '单价'">
              <el-input-number
                v-model="form.price"
                clearable
                size="small"
                style="width:100%"
                :min="0"
                :step="0.01"
                :precision="2"
                controls-position="right"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="this.$l('form_label_qty') || '数量'">
              <el-input-number
                v-model="form.qty"
                clearable
                size="small"
                style="width:100%"
                :min="0"
                :step="1"
                :precision="0"
                controls-position="right"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                this.$l('INDEX.order_goods_label_subAmount') || '小计金额'
              "
            >
              <el-input-number
                v-model="form.subAmount"
                clearable
                size="small"
                style="width:100%"
                :min="0"
                :step="0.01"
                :precision="2"
                controls-position="right"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="this.$l('form_label_expenseDescription') || '费用说明'"
              prop="expenseDescription"
            >
              <el-input
                v-model="form.expenseDescription"
                type="textarea"
                clearable
                size="small"
                rows="2"
                maxlength="500"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from "@/libs/util.validate"
export default {
  props: {
    purchasePackageExpenseCode: String,
    packageDetailCode: String,
    packageCode: String,
    disabled: Boolean,
  },
  data() {
    return {
      form: {},
      rules: {
        expenseType: [
          {
            required: true,
            message:
              this.$l("tips_select_packpgBatchType") ||
              "请选择包装采购执行批次类型",
            trigger: "change",
          },
        ],
        expenseDescription: [
          {
            required: true,
            message:
              this.$l("tips_input_expenseDescription") || "请输入费用说明",
            trigger: "blur",
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.purchasePackageExpenseCode) return
      this.$api
        .purchasePackageExpenseDetailApi({
          purchasePackageExpenseCode: this.purchasePackageExpenseCode,
        })
        .then((res) => {
          this.form = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      let loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      //根据不同的操作调用不同接口
      let saveApi = {}
      if (this.purchasePackageExpenseCode) {
        saveApi = this.$api.purchasePackageExpenseModifyApi({
          ...this.form,
          purchasePackageDetailCode: this.packageDetailCode,
          purchasePackageCode: this.packageCode,
        })
      } else {
        saveApi = this.$api.purchasePackageExpenseAddApi({
          ...this.form,
          purchasePackageDetailCode: this.packageDetailCode,
          purchasePackageCode: this.packageCode,
        })
      }
      saveApi
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || res.msg,
            type: "success",
          })
          this.$emit("close")
          this.$emit("reload")
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  },
}
</script>
